import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity('user_otp')
export class UserOtp {
    @PrimaryGeneratedColumn('increment',{name:'id'}) 
    Id: number;  
    @Column("varchar",{
        nullable:true,
        length:10,
        name:"mobile_no"
    })
    mobileNo:string;
    @Column("varchar",{
        nullable:true,
        length:500,
        name:"email"
    })
    email:string;
    @Column("varchar",{
        nullable:false,
        length:500,
        name:'first_name'
    })
    firstName:string;
    @Column("varchar",{
        nullable:true,
        length:500,
        name:"membership_img"
      })  
      membershipImg:string;
      @Column("varchar",{
        nullable:true,
        length:500,
        name:"membership_id"
      })  
      membershipId:string;
    @Column("int",{
        nullable: false,
        name:"otp"
    })
    otp:number;
    @Column({
        nullable: false,     
        name:"otp_expire",
        type:'datetime'
    })
    otpExpire:Date;
}